export default class Theme {
  private static readonly localStorageThemeVariable: string = 'mf-secure-theme';

  public static get localStorageThemeVar() {
    return this.localStorageThemeVariable;
  }
}
